import { Spoller } from "@plugins";

new Spoller(".js-accordion", {
    duration: 250,
    selectorToggleBtn: ".js-accordion-toggle-btn",
    selectorContent: ".js-accordion-content",
    makeToggleBtnActive: false,
});
